import { render, staticRenderFns } from "./LogsScreen.vue?vue&type=template&id=25632f98&scoped=true"
import script from "./LogsScreen.vue?vue&type=script&lang=js"
export * from "./LogsScreen.vue?vue&type=script&lang=js"
import style0 from "./LogsScreen.vue?vue&type=style&index=0&id=25632f98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25632f98",
  null
  
)

export default component.exports